import Tag from 'components/uiKit.todo/Tag'
import { t } from 'services/Translation'

const TagEdited: React.FC = () => {
  return (
    <Tag bgColor='var(--color-green-alpha)' textColor='var(--color-green)'>
      {t('page.brand.card.changed')}
    </Tag>
  )
}

export default TagEdited
